import { render, staticRenderFns } from "./DesignerView.vue?vue&type=template&id=4c667196"
import script from "./DesignerView.vue?vue&type=script&lang=js"
export * from "./DesignerView.vue?vue&type=script&lang=js"
import style0 from "./DesignerView.vue?vue&type=style&index=0&id=4c667196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports